import type { NextPage } from "next";
import dynamic from "next/dynamic";
import React from "react";

import type { Props } from "nextjs/getServerSideProps/handlers";
import PageNextJs from "nextjs/PageNextJs";

import config from "configs/app";

const Transaction = dynamic(
  () => {
    if (config.features.opSuperchain.isEnabled) {
      return import("ui/optimismSuperchain/tx/OpSuperchainTx");
    }

    return import("ui/pages/Transaction");
  },
  { ssr: false },
);

const Page: NextPage<Props> = (props: Props) => {
  return (
    <PageNextJs pathname="/tx/[hash]" query={props.query}>
      <Transaction />
    </PageNextJs>
  );
};

export default Page;

export { base as getServerSideProps } from "nextjs/getServerSideProps/main";
